export enum BetslipType {
    Single = 'SINGLE',
    Combo = 'COMBO',
    Teaser = 'TEASER',
    System = 'SYSTEM',
    EditBet = 'EDIT_MY_BET',
    BetBuilder = 'BET_BUILDER',
}
